(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryDialogController', BatteryDialogController);

    BatteryDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Battery', 'BatteryTest'];

    function BatteryDialogController ($scope, $stateParams, $uibModalInstance, entity, Battery, BatteryTest) {
        var vm = this;
        vm.battery = entity;
        vm.batterytests = BatteryTest.query();
        vm.load = function(id) {
            Battery.get({id : id}, function(result) {
                vm.battery = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:batteryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.battery.id !== null) {
                Battery.update(vm.battery, onSaveSuccess, onSaveError);
            } else {
                Battery.save(vm.battery, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
